module.exports = __webpack_public_path__ + "static/media/027.c8c70821.jpg";